/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  NewParish,
  Parish,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
} from '../models/index';
import {
    NewParishFromJSON,
    NewParishToJSON,
    ParishFromJSON,
    ParishToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
} from '../models/index';

export interface ParishCountRequest {
    where?: string;
}

export interface ParishCreateRequest {
    data?: NewParish;
}

export interface ParishCreateChangeStreamGetParishesChangeStreamRequest {
    options?: string;
}

export interface ParishCreateChangeStreamPostParishesChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface ParishDeleteByIdRequest {
    id: string;
}

export interface ParishExistsGetParishesidExistsRequest {
    id: string;
}

export interface ParishExistsHeadParishesidRequest {
    id: string;
}

export interface ParishFindRequest {
    filter?: string;
}

export interface ParishFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ParishFindOneRequest {
    filter?: string;
}

export interface ParishPatchOrCreateRequest {
    data?: Parish;
}

export interface ParishPrototypePatchAttributesRequest {
    id: string;
    data?: Parish;
}

export interface ParishReplaceByIdPostParishesidReplaceRequest {
    id: string;
    data?: Parish;
}

export interface ParishReplaceByIdPutParishesidRequest {
    id: string;
    data?: Parish;
}

export interface ParishReplaceOrCreatePostParishesReplaceOrCreateRequest {
    data?: Parish;
}

export interface ParishReplaceOrCreatePutParishesRequest {
    data?: Parish;
}

export interface ParishUpdateAllRequest {
    where?: string;
    data?: Parish;
}

export interface ParishUpsertWithWhereRequest {
    where?: string;
    data?: Parish;
}

/**
 * 
 */
export class ParishApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async parishCountRaw(requestParameters: ParishCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Parishes/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async parishCount(requestParameters: ParishCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.parishCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async parishCreateRaw(requestParameters: ParishCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async parishCreate(requestParameters: ParishCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async parishCreateChangeStreamGetParishesChangeStreamRaw(requestParameters: ParishCreateChangeStreamGetParishesChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Parishes/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async parishCreateChangeStreamGetParishesChangeStream(requestParameters: ParishCreateChangeStreamGetParishesChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.parishCreateChangeStreamGetParishesChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async parishCreateChangeStreamPostParishesChangeStreamRaw(requestParameters: ParishCreateChangeStreamPostParishesChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async parishCreateChangeStreamPostParishesChangeStream(requestParameters: ParishCreateChangeStreamPostParishesChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.parishCreateChangeStreamPostParishesChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async parishDeleteByIdRaw(requestParameters: ParishDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parishDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Parishes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async parishDeleteById(requestParameters: ParishDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.parishDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async parishExistsGetParishesidExistsRaw(requestParameters: ParishExistsGetParishesidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parishExistsGetParishesidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Parishes/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async parishExistsGetParishesidExists(requestParameters: ParishExistsGetParishesidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.parishExistsGetParishesidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async parishExistsHeadParishesidRaw(requestParameters: ParishExistsHeadParishesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parishExistsHeadParishesid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Parishes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async parishExistsHeadParishesid(requestParameters: ParishExistsHeadParishesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.parishExistsHeadParishesidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async parishFindRaw(requestParameters: ParishFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Parish>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Parishes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParishFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async parishFind(requestParameters: ParishFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Parish>> {
        const response = await this.parishFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async parishFindByIdRaw(requestParameters: ParishFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parishFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Parishes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async parishFindById(requestParameters: ParishFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async parishFindOneRaw(requestParameters: ParishFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Parishes/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async parishFindOne(requestParameters: ParishFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async parishPatchOrCreateRaw(requestParameters: ParishPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async parishPatchOrCreate(requestParameters: ParishPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async parishPrototypePatchAttributesRaw(requestParameters: ParishPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parishPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async parishPrototypePatchAttributes(requestParameters: ParishPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async parishReplaceByIdPostParishesidReplaceRaw(requestParameters: ParishReplaceByIdPostParishesidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parishReplaceByIdPostParishesidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async parishReplaceByIdPostParishesidReplace(requestParameters: ParishReplaceByIdPostParishesidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishReplaceByIdPostParishesidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async parishReplaceByIdPutParishesidRaw(requestParameters: ParishReplaceByIdPutParishesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parishReplaceByIdPutParishesid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async parishReplaceByIdPutParishesid(requestParameters: ParishReplaceByIdPutParishesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishReplaceByIdPutParishesidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async parishReplaceOrCreatePostParishesReplaceOrCreateRaw(requestParameters: ParishReplaceOrCreatePostParishesReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async parishReplaceOrCreatePostParishesReplaceOrCreate(requestParameters: ParishReplaceOrCreatePostParishesReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishReplaceOrCreatePostParishesReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async parishReplaceOrCreatePutParishesRaw(requestParameters: ParishReplaceOrCreatePutParishesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async parishReplaceOrCreatePutParishes(requestParameters: ParishReplaceOrCreatePutParishesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishReplaceOrCreatePutParishesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async parishUpdateAllRaw(requestParameters: ParishUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async parishUpdateAll(requestParameters: ParishUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.parishUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async parishUpsertWithWhereRaw(requestParameters: ParishUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Parish>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Parishes/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParishToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParishFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async parishUpsertWithWhere(requestParameters: ParishUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Parish> {
        const response = await this.parishUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
